const digest = '5a5aee5f3da484bdefcb6a08cbeef84e2a6453fd74ea2c74687dac148333b143';
const css = `._inavLite_1yr59_1{background:#fff;left:0;position:fixed;top:0;z-index:99}._inavHeight_1yr59_9{height:3.9rem}._logoLine_1yr59_13{display:inline-block;height:18px;width:280px}._mobileLogo_1yr59_19{margin-left:16px}._cursorPointer_1yr59_23{cursor:pointer}._exitBtn_1yr59_27{min-width:max-content}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'inavLite': '_inavLite_1yr59_1', 'inavHeight': '_inavHeight_1yr59_9', 'logoLine': '_logoLine_1yr59_13', 'mobileLogo': '_mobileLogo_1yr59_19', 'cursorPointer': '_cursorPointer_1yr59_23', 'exitBtn': '_exitBtn_1yr59_27' };
export const inavLite = '_inavLite_1yr59_1';
export const inavHeight = '_inavHeight_1yr59_9';
export const logoLine = '_logoLine_1yr59_13';
export const mobileLogo = '_mobileLogo_1yr59_19';
export const cursorPointer = '_cursorPointer_1yr59_23';
export const exitBtn = '_exitBtn_1yr59_27';
export { css, digest };